module.exports = __webpack_public_path__ + "img/aside-img-login.06875eb2.png";